import React, { useEffect, useMemo, useState, useCallback } from "react"
import PropTypes from "prop-types"
import { Link, useHistory } from "react-router-dom"
import { isEmpty } from "lodash"
import "bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../../components/Common/TableContainer"
import * as Yup from "yup"
import { useFormik } from "formik"

//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"

// import {
//   getUsers as onGetUsers,
//   addNewUser as onAddNewUser,
//   updateUser as onUpdateUser,
//   deleteUser as onDeleteUser,
// } from "../../../store/actions"

import {
  // Position,
 Name_ar,Name_en,Name_fr,IsActive, Discount_value
} from "./Vendor_CatListCol"

//redux
import { useSelector, useDispatch } from "react-redux"

import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  Spinner,
} from "reactstrap"
import DeleteModal from "../../../components/Common/DeleteModal"
import { addNewAdmin, deleteAdmin, getAdmins, updateAdmin } from "../../../store/admins/actions"
import { addNewVendor_cat, deleteVendor_cat, getVendor_cats, updateVendor_cat } from "../../../store/vendor_cat/actions"
import imageBaseUrl from "../../../helpers/imageBaseUrl"
import Dropzone from "react-dropzone"
import InputColor from "react-input-color"

function Vendor_cats() {
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [offset,setOffset]=useState(0)
  const [page_size, setPageSize] = useState(10)
  const [vendor_cat, setVendor_cat] = useState([])
  const [selectedFiles, setselectedFiles] = useState([])
  const [color,setColor] = useState('')

  function handleAcceptedFiles(files) {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size),
      })
    )
  
    setselectedFiles(files)
  
  }
  
  /**
   * Formats the size
   */
  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
  
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      cat_name_en: (vendor_cat && vendor_cat.cat_name_en) || "",
      cat_name_ar: (vendor_cat && vendor_cat.cat_name_ar) || "",
      cat_name_fr: (vendor_cat && vendor_cat.cat_name_fr) || "",
      discount_value: (vendor_cat && vendor_cat.discount_value) || 0,
      is_active: (vendor_cat && vendor_cat.is_active) || 0,
    },

    validationSchema: Yup.object({
      cat_name_ar: Yup.string().required("name ar is required"),
      cat_name_fr: Yup.string().required("name fr is required"),
      cat_name_en: Yup.string().required("name en is required"),
    }),
    
    onSubmit: values => {

      if (isEdit) {
        const UpdateVendor_cat = {
          id: vendor_cat ? vendor_cat.id : 0,
          cat_name_en: values["cat_name_en"],
          cat_name_fr: values["cat_name_fr"],
          cat_name_ar: values["cat_name_ar"],
          discount_value: values["discount_value"],

          color:color,
          is_active: values['is_active'],
          image: selectedFiles[0],
          removeImage: vendor_cat.removeImage ? 1 : 0,
        }

        // update vendor_cat
        dispatch(updateVendor_cat(UpdateVendor_cat))
        validation.resetForm()
      } else {
        const newVendor_cat = {
          // id: Math.floor(Math.random() * (30 - 20)) + 20,
          cat_name_en: values["cat_name_en"],
          cat_name_fr: values["cat_name_fr"],
          cat_name_ar: values["cat_name_ar"],
          discount_value: values["discount_value"],
          is_active: values['is_active'],
          color:color,
          image:selectedFiles[0]
        }
        // save new vendor_cat
        dispatch(addNewVendor_cat(newVendor_cat))
        validation.resetForm()
      }
      // toggle()
    },
  })

  const dispatch = useDispatch()
  const history = useHistory()
  const vendor_cats = useSelector(state => state.vendors.vendor_cats.vendor_cats)
  const loading = useSelector(state => state.vendors.vendor_cats.loading)
  const total_page = useSelector(state => state.vendors.vendor_cats.total_page)

  useEffect(() => {
      dispatch(getVendor_cats({is_active:0,offset,page_size}))
  }, [dispatch,offset,page_size])

  // useEffect(() => {
  //   if (vendor_cats && !vendor_cats.length) {
  //     dispatch(onGetUsers())
  //   }
  // }, [dispatch, vendor_cats])

  // useEffect(() => {
  // }, [vendor_cats])

  useEffect(() => {
    if (!isEmpty(vendor_cats)) {
      setIsEdit(false)
    }
  }, [vendor_cats])

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false)
      setVendor_cat(null)
    } else {
      setModal(true)
    }
  }, [modal]);

  const handleUserClick = useCallback((arg) => {
    const vendor_cat = arg
    setColor(vendor_cat?.color)
    vendor_cat?.image ? setselectedFiles([
      {
        preview:imageBaseUrl+vendor_cat.image
      }
    ]) : setselectedFiles([])
    setVendor_cat({
      id: vendor_cat.id,
      cat_name_ar: vendor_cat.cat_name_ar,
      cat_name_fr: vendor_cat.cat_name_fr,
      cat_name_en: vendor_cat.cat_name_en,
      discount_value: vendor_cat.discount_value,
      is_active:vendor_cat.is_active

    })
    setIsEdit(true)
    toggle()
  }, [toggle])

  //delete vendor_cat
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = vendor_cat => {
    setVendor_cat(vendor_cat)
    setDeleteModal(true)
  }

  const handleDeleteUser = () => {
    if (vendor_cat.id) {
      dispatch(deleteVendor_cat(vendor_cat))
      // setDeleteModal(false)
    }
  }
  useEffect(() => {
    if(!loading){
      setDeleteModal(false)
           setModal(false) 
    } 

  },[loading])
  const handleUserClicks = () => {
    setIsEdit(false)
    toggle()
  }
  const columns = useMemo(
    () => [
      // {
      //   Header: "Id",
      //   accessor: "checkbox",
      //   disableFilters: true,
      //   filterable: false,
      //   Cell: cellProps => {
      //     return <input type="checkbox" className="selection-input-4" />
      //   },
      // },
      {
        Header: "Image",

        filterable: true,
        disableFilters: true,
        accessor: cellProps => (
          <React.Fragment>
            {!cellProps.image ? (
              <div className="avatar-xs d-inline-block me-2">
                <div className="avatar-title bg-soft-primary rounded-circle text-primary">
                  <i className="mdi mdi-account-circle m-0"></i>
                </div>
              </div>
            ) : (
              <img
                className="avatar-xs rounded-circle me-2"
                src={imageBaseUrl + cellProps.image}
                alt=""
              />
            )}
          </React.Fragment>
        ),
      },
      {
        Header: "category name en",
        accessor: "cat_name_en",
        filterable: true,
        Cell: cellProps => {
          return <Name_en {...cellProps} />
        },
      },
      // {
      //   Header: "Position",
      //   accessor: "designation",
      //   filterable: true,
      //   Cell: cellProps => {
      //     return <Position {...cellProps} />
      //   },
      // },
      {
        Header: "Category name fr",
        accessor: "cat_name_fr",
        filterable: true,
        Cell: cellProps => {
          return <Name_fr {...cellProps} />
        },
      },
      {
        Header: "category name ar",
        accessor: "cat_name_ar",
        filterable: true,

        Cell: cellProps => {
          return <Name_ar {...cellProps} />
        },
      },
      {
        Header: "discount value",
        accessor: "discount_value",
        filterable: true,

        Cell: cellProps => {
          return <Discount_value {...cellProps} />
        },
      },
      {
        Header: "Active",
        accessor: "is_active",
        filterable: true,
        disableFilters: true,

        Cell: cellProps => (
          // {
          //   return <IsActive {...cellProps} />
          // },
          <div className="form-check form-switch form-switch-lg">
            {cellProps.value == 1 ? (
              <input
                disabled={loading}
                onClick={e =>
                  dispatch(
                    updateVendor_cat({
                      is_active: 0,
                      id: cellProps.row.original.id,
                    })
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={true}
              />
            ) : (
              <input
                disabled={loading}
                onClick={e =>
                  dispatch(
                    updateVendor_cat({
                      is_active: 1,
                      id: cellProps.row.original.id,
                    })
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={false}
              />
            )}
          </div>
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3 users">
              <ul className="list-inline font-size-20 contact-links mb-0">
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-primary"
                    onClick={() => {
                      const vendor_cats = cellProps.row.original
                      handleUserClick(vendor_cats)
                    }}
                  >
                    <i className="uil uil-pen font-size-18" id="edittooltip" />
                    <UncontrolledTooltip placement="top" target="edittooltip">
                      Edit
                    </UncontrolledTooltip>
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-danger"
                    onClick={() => {
                      const vendor_cats = cellProps.row.original
                      onClickDelete(vendor_cats)
                    }}
                  >
                    <i
                      className="uil uil-trash-alt font-size-18"
                      id="deletetooltip"
                    />
                    <UncontrolledTooltip placement="top" target="deletetooltip">
                      Delete
                    </UncontrolledTooltip>
                  </Link>
                </li>
                <li className="list-inline-item dropdown">
                  <UncontrolledDropdown>
                    <DropdownToggle
                      tag="a"
                      className="text-muted font-size-18 px-2"
                      caret
                    >
                      <i className="uil uil-ellipsis-v"></i>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                      <DropdownItem onClick={()=>history.push('/vendor-type-services/'+cellProps.row.original.id)}>services</DropdownItem>
                      <DropdownItem onClick={()=>history.push('/vendor-type-settings/'+cellProps.row.original.id)}>service types</DropdownItem>
                      {/* <DropdownItem href="#">Another action</DropdownItem>
                      <DropdownItem href="#">Something else here</DropdownItem> */}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </li>
              </ul>
            </div>
          )
        },
      },
    ],
    [handleUserClick]
  )

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
        loading={loading}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="MENU" breadcrumbItem="Vendor categories" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={vendor_cats}
                    isGlobalFilter={true}
                    isAddUsers={true}
                    isAddTableWithoutBorderStrap={true}
                    handleUserClicks={handleUserClicks}
                    setPage={setOffset}
                    page_number={offset}
                    total_pages={total_page}
                    setPageSize={setPageSize}
                    page_size={page_size}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Edit User" : "Add Users"}
            </ModalHeader>
            <ModalBody>
              <Form
                onSubmit={e => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}
              >
                <Dropzone
                  onDrop={acceptedFiles => {
                    handleAcceptedFiles(acceptedFiles)
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div className="dropzone">
                      <div
                        className="dz-message needsclick"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        <div className="mb-3">
                          <i className="display-4 text-muted uil uil-cloud-upload" />
                        </div>
                        <h4>Drop files here or click to upload.</h4>
                      </div>
                    </div>
                  )}
                </Dropzone>
                <div className="dropzone-previews mt-3" id="file-previews">
                  {selectedFiles.map((f, i) => {
                    return (
                      <Card
                        className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                        key={i + "-file"}
                      >
                        <div
                          className="p-2"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Row className="align-items-center">
                            <Col className="col-auto">
                              <img
                                data-dz-thumbnail=""
                                height="80"
                                className="avatar-sm rounded bg-light"
                                alt={f.name}
                                src={f.preview}
                              />
                            </Col>
                            <Col>
                              <Link
                                to="#"
                                className="text-muted font-weight-bold"
                              >
                                {f.name}
                              </Link>
                              <p className="mb-0">
                                <strong>{f.formattedSize}</strong>
                              </p>
                            </Col>
                          </Row>
                          <div
                            className="align-self-center"
                            onClick={() => {
                              setselectedFiles([])
                              setVendor_cat(prev => ({
                                ...prev,
                                removeImage: 1,
                              }))
                            }}
                          >
                            <i
                              className="uil uil-trash-alt font-size-24 text-danger"
                              id="deletetooltip"
                            />
                            <UncontrolledTooltip
                              placement="top"
                              target="deletetooltip"
                            >
                              Delete
                            </UncontrolledTooltip>
                          </div>
                        </div>
                      </Card>
                    )
                  })}
                </div>
                <Row>
                  <Col className="col-12">
                    {/* <div className="mb-3">
                      <Label className="form-label">Position</Label> */}
                    {/* <Input
                        name="designation"
                        type="designation"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.designation || ""}
                        invalid={
                          validation.touched.designation &&
                          validation.errors.designation
                            ? true
                            : false
                        }
                      /> */}
                    {/* {validation.touched.designation &&
                      validation.errors.designation ? (
                        <FormFeedback type="invalid">
                          {validation.errors.designation}
                        </FormFeedback>
                      ) : null} */}
                    {/* </div> */}
                    <div className="mb-3">
                      <Label className="form-label">Name en</Label>
                      <Input
                        name="cat_name_en"
                        type="text"
                        validate={{
                          required: { value: true },
                        }}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.cat_name_en || ""}
                        invalid={
                          validation.touched.cat_name_en &&
                          validation.errors.cat_name_en
                            ? true
                            : false
                        }
                      />
                      {validation.touched.cat_name_en &&
                      validation.errors.cat_name_en ? (
                        <FormFeedback type="invalid">
                          {validation.errors.cat_name_en}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Name fr</Label>
                      <Input
                        name="cat_name_fr"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.cat_name_fr || ""}
                        invalid={
                          validation.touched.cat_name_fr &&
                          validation.errors.cat_name_fr
                            ? true
                            : false
                        }
                      />
                      {validation.touched.cat_name_fr &&
                      validation.errors.cat_name_fr ? (
                        <FormFeedback type="invalid">
                          {validation.errors.cat_name_fr}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Name ar</Label>
                      <Input
                        name="cat_name_ar"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.cat_name_ar || ""}
                        invalid={
                          validation.touched.cat_name_ar &&
                          validation.errors.cat_name_ar
                            ? true
                            : false
                        }
                      />
                      {validation.touched.cat_name_ar &&
                      validation.errors.cat_name_ar ? (
                        <FormFeedback type="invalid">
                          {validation.errors.cat_name_ar}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Discount value</Label>
                      <Input
                        name="discount_value"
                        type="number"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.discount_value || ""}
                        invalid={
                          validation.touched.discount_value &&
                          validation.errors.discount_value
                            ? true
                            : false
                        }
                      />
                      {validation.touched.discount_value &&
                      validation.errors.discount_value ? (
                        <FormFeedback type="invalid">
                          {validation.errors.discount_value}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Color</Label>
                      <InputColor
        initialValue={color}
        onChange={(obj)=>setColor(obj.hex)}
        placement="right"
      />
                    </div>
                    <div className="mb-3">
                      {validation.values.is_active === 1 ? (
                        <input
                          type="checkbox"
                          className="selection-input-4 m-1"
                          defaultChecked
                          onClick={() => (validation.values.is_active = 0)}
                        />
                      ) : (
                        <input
                          type="checkbox"
                          className="selection-input-4 m-1"
                          onClick={() => (validation.values.is_active = 1)}
                        />
                      )}
                      {/* <input
                        type="checkbox"
                        className="selection-input-4 m-1"
                        defaultChecked={
                          validation.values.is_active === 1 ? true : false
                        }
                      /> */}
                      <Label className="form-label">Active</Label>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      {loading ? (
                        <Spinner
                          type="grow"
                          className="m-1 center"
                          color="primary"
                        />
                      ) : (
                        <button
                          type="submit"
                          className="btn btn-success save-user"
                        >
                          Save
                        </button>
                      )}
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  )
}
Vendor_cats.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default Vendor_cats
